module.exports = __webpack_public_path__ + "static/media/display.51508e40.png";